/**
 * Created by razial on 15.04.2026.
 */

const MultiRewardedPromo = function () {
    this.pending = {};
    this.sendTimeout = undefined;
};

MultiRewardedPromo.prototype.loadData = function (crossId, callback = () => {}) {
    ConnectorRestClient.post(`${connector.config.multiApiURL}/promotasks/get/${crossId}`, {}, (data) => {
        callback(undefined, data);
    }, (error) => {
        callback(error);
    });
};

MultiRewardedPromo.prototype.updateData = function (crossId, data) {
    const deepAssign = function (target, source) {
        for (const key of Object.keys(source)) {
            const value = source[key];
            if (value && typeof value === "object" && !Array.isArray(value)
                && target[key] && typeof target[key] === "object" && !Array.isArray(target[key])) {
                deepAssign(target[key], value);
            } else {
                target[key] = value;
            }
        }
        return target;
    };

    if (!this.pending[crossId]) {
        this.pending[crossId] = {};
    }

    deepAssign(this.pending[crossId], data);

    if (!this.sendTimeout) {
        this.sendTimeout = setTimeout(() => {
            this.sendTimeout = undefined;
            this.flush();
        }, 500);
    }
};

MultiRewardedPromo.prototype.flush = function () {
    if (this.sendTimeout) {
        clearTimeout(this.sendTimeout);
        this.sendTimeout = undefined;
    }

    const pending = this.pending;
    this.pending = {};

    Object.keys(pending).forEach((crossId) => {
        ConnectorRestClient.post(`${connector.config.multiApiURL}/promotasks/update/${crossId}`, pending[crossId], () => {}, () => {});
    });
};
